// extracted by mini-css-extract-plugin
export default {"tupacGrid":"km-z","tupacHeader":"lm-z","tupacHeader2":"mm-z","tupacMenu":"nm-z","tupacMenu2":"om-z","tupacMain":"pm-z","tupacMain2":"qm-z"};